import { adminAPIService } from './index'

const route = 'private-clients'

export default {
  getClientList() {
    return adminAPIService({
      url: `${route}`,
      method: 'get',
    })
  },
  getClient(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  createClient(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}`,
      method: 'post',
      data: body,
    })
  },
  editClient(id, detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  getAddressList(privateClientId) {
    return adminAPIService({
      url: `${route}/addresses?private_client_id=${privateClientId}`,
      method: 'get',
    })
  },
  getAddress(id) {
    return adminAPIService({
      url: `${route}/addresses/${id}`,
      method: 'get',
    })
  },
  createAddress(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/addresses`,
      method: 'post',
      data: body,
    })
  },
  editAddress(id, detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/addresses/${id}`,
      method: 'post',
      data: body,
    })
  },
  getProfileList(privateClientId) {
    return adminAPIService({
      url: `${route}/profiles?private_client_id=${privateClientId}`,
      method: 'get',
    })
  },
  getProfile(id) {
    return adminAPIService({
      url: `${route}/profiles/${id}`,
      method: 'get',
    })
  },
  createProfile(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/profiles`,
      method: 'post',
      data: body,
    })
  },
  editProfile(id, detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/profiles/${id}`,
      method: 'post',
      data: body,
    })
  },
  getOrderList(params) {
    return adminAPIService({
      url: `${route}/orders`,
      method: 'get',
      params,
    })
  },
  getOrderItemList(privateClientId) {
    return adminAPIService({
      url: `${route}/order-items?private_client_id=${privateClientId}`,
      method: 'get',
    })
  },
  getLikedProductList(privateClientId) {
    return adminAPIService({
      url: `${route}/liked-products?private_client_id=${privateClientId}`,
      method: 'get',
    })
  },
  getOrderDetail(id) {
    return adminAPIService({
      url: `${route}/orders/${id}`,
      method: 'get',
    })
  },
  createOrder(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/orders`,
      method: 'post',
      data: body,
    })
  },
  updateOrder(detail, id) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))

    for (let i = 0; i < detail.external_orders.length; i++) {
      if (detail.external_orders[i].order_confirmation !== null) {
        formData.append(`order_confirmation__${i}`, detail.external_orders[i].order_confirmation)
      }
    }

    return adminAPIService({
      url: `${route}/orders/${id}`,
      method: 'post',
      data: formData,
    })
  },
  requestPartialRefundOrder(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/orders/${id}/request-partial-refund`,
      method: 'post',
      data: body,
    })
  },
  requestFullRefundOrder(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/orders/${id}/request-full-refund`,
      method: 'post',
      data: body,
    })
  },
  getOrderRefundRequestList() {
    return adminAPIService({
      url: `${route}/order-refund-requests`,
      method: 'get',
    })
  },
  processOrderRefundRequest(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/order-refund-requests/${id}/process`,
      method: 'post',
      data: body,
    })
  },
  getOrderStoreList(orderId) {
    return adminAPIService({
      url: `${route}/orders/${orderId}/stores`,
      method: 'get',
    })
  },
  getStoreList() {
    return adminAPIService({
      url: `${route}/stores`,
      method: 'get',
    })
  },
  getCourierList() {
    return adminAPIService({
      url: `${route}/couriers`,
      method: 'get',
    })
  },
  getShopperList() {
    return adminAPIService({
      url: `${route}/shoppers`,
      method: 'get',
    })
  },
  getSalesReport(params) {
    return adminAPIService({
      url: `${route}/sales-report`,
      method: 'get',
      params,
    })
  },
  getMerchantSalesReport(params) {
    return adminAPIService({
      url: `${route}/merchant-sales-report`,
      method: 'get',
      params,
    })
  },
}